import clientConfig from '@/client-config.json';

// export const API_URL = 'http://localhost:8107'
export const API_URL = 'https://igente-backend-73af5cb0649a.herokuapp.com'

export const APP_TOKEN = clientConfig.APP_TOKEN;
export const LOCALSTORAGE_ACCESS_TOKEN = clientConfig.LOCALSTORAGE_ACCESS_TOKEN;
export const LOCALSTORAGE_REFRESH_TOKEN = clientConfig.LOCALSTORAGE_REFRESH_TOKEN;